import React, { useEffect, useState } from "react";
import { Row, Col, Spinner, ListGroup } from "react-bootstrap";
import Plot from 'react-plotly.js';

import { useGlobalState } from '../../../components/globalStateProvider.js';
import MachineTableConnected from './MachineTableConnected.js';
import { machineOnFleetTableAPI } from '../../../api/api_definitions.js';


const MachineInfoConnected = () => {


  const [loading, setLoading] = useState(true);
  const [startAnalysis, setStartAnalysis] = useState(false);

  const {
    machineFamilyConnectedTrigger,
    infoMachineConnectedTrigger, setInfoMachineConnectedTrigger,
    tableMachineConnectedTrigger, setTableMachineConnectedTrigger
  } = useGlobalState();

  
  // API GATEWAY RESPONSE MANAGEMENT --> Return list of laser machine family connected to cloud
  useEffect(() => {
    setStartAnalysis(true)
    setLoading(true)
    let isMounted = true;
    machineOnFleetTableAPI(machineFamilyConnectedTrigger)
      .then((dataAPI) => {
        if (isMounted) {
          console.log("Data", dataAPI)
          setInfoMachineConnectedTrigger(dataAPI)  
          if (dataAPI !== null) {
            setTableMachineConnectedTrigger(JSON.parse(dataAPI.DF))
          }
          setLoading(false)
        }
      }
     )
      .catch((error) => {
        console.log(error)
        setStartAnalysis(false)
        setLoading(true)
    });
    return () => {
      isMounted = false;
    };
  }, [machineFamilyConnectedTrigger, setInfoMachineConnectedTrigger, setTableMachineConnectedTrigger])

  // Return loading layout
  if (startAnalysis & loading) {
    return (
      <Row className="d-flex flex-column align-items-center justify-content-center text-center">
        <p className="mt-4">Caricamento dati...</p>
        <Spinner animation="border" role="status"></Spinner>
      </Row>
    )
  }

  // Return layout
  if (infoMachineConnectedTrigger!==null) {

    const lenDF        = Object.values(Object.values(tableMachineConnectedTrigger)[0]).length;
    const currentPosts = Object.values(tableMachineConnectedTrigger).map(i => Object.values(i).slice(0, lenDF));
    const colors       = ["darkgreen", "darkorange", "red"];
    const labels       = ['Macchine ATTIVE', 'Macchine INATTIVE', 'Macchine MAI ATTIVE'];
    const values       = [Number(infoMachineConnectedTrigger.Count_ACTIVE_TRIGGER), Number(infoMachineConnectedTrigger.Count_INACTIVE_TRIGGER), Number(infoMachineConnectedTrigger.Count_NEVERACTIVE_TRIGGER)];

    const plotData = [{
      values: values,
      labels: labels,
      type: 'pie',
      marker: { colors: colors },
      sort: false 
    }];

    const plotLayout = {
      width: 500,
      height: 500,
      legend: { 
        itemsizing: 'constant',
        orientation: 'h',
        x: 0.5,
        y: 1.5,
        xanchor: 'center',
        yanchor: 'top'
        }, 
      categoryorder: 'array', 
      categoryarray: labels 
    };
  
    // Return layout
    return (
        <>
          { tableMachineConnectedTrigger && (
            <>
              <Row className="text-center">
                <Col md={{ span: 6, offset: 3 }}>
                  <h4>Macchine connesse: {Number(infoMachineConnectedTrigger.Count_ACTIVE_TRIGGER)} / {Number(infoMachineConnectedTrigger.CountAll)}</h4>
                </Col>
              </Row>

              <Row className="text-center">
                <Col md={{ span: 6, offset: 3 }}>
                  <Plot data={plotData} layout={plotLayout}/>
                </Col>
              </Row>


              <Row className="text-center">
                <Col md={{ span: 6, offset: 3 }}>
                  <h4>Elenco stato di connessione delle macchine</h4>
                </Col>
              </Row>

              <Row className="mt-4 mb-4">
                <MachineTableConnected columns={Object.keys(tableMachineConnectedTrigger)} posts={currentPosts} />
              </Row>

              <Row className="mt-3 mb-5">
                <h5>Legenda:</h5>
                <ListGroup>
                    <ListGroup.Item style={{ backgroundColor:'rgba(150, 40, 27, 0.9)', color:'white', width:'30%', }}>Dato MAI ATTIVO</ListGroup.Item>
                    <ListGroup.Item style={{ backgroundColor:'rgba(255, 165, 0, 0.9)',width:'30%', }}>Dato NON ATTIVO</ListGroup.Item>
                    <ListGroup.Item style={{ width:'30%', }}>Dato ATTIVO</ListGroup.Item>
                </ListGroup>
              </Row>
            </>
          )}
        </>
      )    
  }

}

export default MachineInfoConnected;
